import { useEffect, useState } from 'react';

import { toastError } from '@/components/Toast';

const FabricSustainabilityTable = ({ data = [], onChange, isEditable = true }) => {
	const [fiberRequirements, setFiberRequirements] = useState([]);

	useEffect(() => {
		setFiberRequirements(data);
	}, [data]);

	const handleInputChange = (index, value) => {
		if (!isEditable) return;

		if (value > 100 || value < 0) {
			toastError('Percentage must be between 0 and 100');
			return;
		}
		const updatedFiberRequirements = fiberRequirements.map((fiber, i) =>
			i === index ? { ...fiber, percentage: value } : fiber
		);
		setFiberRequirements(updatedFiberRequirements);
		onChange?.(updatedFiberRequirements);
	};

	return (
		<div className="single-table trims-content border mb-5">
			<div className="table-heading mb-0 d-flex align-items-center justify-content-between">
				<p className="regular-14 weight-500 gray_dark_01">Fabric Sustainability</p>
			</div>
			{fiberRequirements.map((fiber, index) => (
				<div className="row align-items-center py-2 border-bottom border-top m-0" key={index}>
					<div className="col-md-2 pr-0">
						<p className="regular-12 gray_dark_02 pb-1 pl-2">
							{fiber.fiber} <span>%</span>
						</p>
					</div>
					<div className="col-md-10">
						<input
							type="number"
							value={fiber.percentage}
							onChange={(e) => handleInputChange(index, e.target.value)}
							readOnly={!isEditable}
						/>
					</div>
				</div>
			))}
		</div>
	);
};

export default FabricSustainabilityTable;
